import { useEffect } from 'react'

export const useGTM = (gtmId?: string, dataLayer: any[] = []) => {
  useEffect(() => {
    if (!gtmId) {
      return
    }
    if (typeof window === 'undefined') {
      return
    }

    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    window.dataLayer = dataLayer
    const script = document.createElement('script')
    script.innerHTML = `
      ;(function(w, d, s, l, i) {
        w[l] = w[l] || []
        w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' })
        var f = d.getElementsByTagName(s)[0],
          j = d.createElement(s),
          dl = l != 'dataLayer' ? '&l=' + l : ''
        j.async = true
        j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl
        f.parentNode.insertBefore(j, f)
      })(window, document, 'script', 'dataLayer', '${gtmId}')
      `
    document.head.insertBefore(script, document.head.childNodes[0])
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
}
